$(function () {
    $('.site-footer .back-link').on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        });

        $(this).blur();
    });
});
